<script>
  import { sortBy } from 'lodash';
  import NotificationDrawerItem from '@/components/base/NotificationDrawerItem.vue';
  import { GameLauncher } from '@/mixins/game-launcher';
  import { BANK_IDS } from '@/store';

  export default {
    name: 'notificationDrawer',

    components: {
      NotificationDrawerItem,
    },

    mixins: [GameLauncher],

    props: {},

    data: () => ({
      tab: 0,
    }),

    created() {
      this.$store.dispatch('getfriendslist');
    },
    computed: {
      tabs() {
        return [
          {
            value: 'all',
            data: sortBy([...this.alertMessages], 'timestamp').reverse(),
          },
          {
            value: 'rewards',
            data: sortBy(this.alertRewards, 'timestamp').reverse(),
          },
          {
            value: 'requests',
            data: sortBy([...this.alertRequests], 'timestamp').reverse(),
          },
        ];
      },
      alertMessages() {
        return this.$store?.getters?.alerts?.filter((item) => !item.deleted) || [];
      },
      alertRequests() {
        return (
          this.$store?.getters?.alerts
            ?.filter((entry) => entry.type === 'REQUEST' || entry.type === 'FRIEND_REQUEST')
            ?.filter((item) => !item.deleted) || []
        );
      },
      alertRewards() {
        return (
          this.$store?.getters?.alerts?.filter((entry) => entry.type === 'REWARD')?.filter((item) => !item.deleted) ||
          []
        );
      },
    },

    methods: {
      async acceptChallenge(privateRoomId, item, alertKey) {
        const addFriendUrl = process.env.VUE_APP_ADD_FRIEND_URL;
        const { balance } = this.$store.getters.getUserTotalBalance;
        let bankId = item.coin === 'QC' || item.coin === BANK_IDS.MQC ? BANK_IDS.MQC : BANK_IDS.MMC;
        const hasBalance = bankId === BANK_IDS.MQC ? balance.MQC > 0 : balance.MMC > 0;

        let isBalanceSufficient =
          bankId === BANK_IDS.MQC ? balance.MQC >= (item.buyIn || 0) : balance.MMC >= (item.buyIn || 0);

        if (!hasBalance || !isBalanceSufficient) {
          this.$store.dispatch('showConfirmDialog', {
            title: 'Insufficient balance',
            text: 'In order to accept this invitation, please deposit to your balance.',
            yesText: 'Deposit Now',
            noText: 'Cancel',
            callback: () => {
              this.$store.dispatch('setWalletDialog', {
                value: true,
                tab: 'purchase',
              });
            },
          });
          return;
        }
        if (this.isUnityGame(item.gameId)) {
          const homeUrl = process.env.VUE_APP_CHALLENGE_URL;
          await this.launchGameUnity(
            item.gameId,
            homeUrl,
            addFriendUrl,
            'extended',
            item.buyIn,
            false,
            item.hostId,
            privateRoomId,
            item.coin || null,
          );
          await this.$store.dispatch('clearsinglealert', alertKey);
        } else {
          await this.$store.dispatch('clearsinglealert', alertKey);

          let response = await this.$store.dispatch('acceptchallenge', {
            privateRoomId: privateRoomId,
          });

          await this.$store.dispatch('clearsinglealert', alertKey);

        if (!response.haserror) {
          await this.enterPrivateRoom(privateRoomId, "CAF", addFriendUrl);
        }
      }
    },
    isUnityGame(gameId) {
      if (this.$store.getters.getActiveGames.length > 0) {
        const game = this.$store.getters.getActiveGames.find(game => game.key === String(gameId));
        return game ? game.unityGame : false;
      } else {
        return false;
      }
    },
    async declineChallenge(privateRoomId, item, alertKey) {
      if (this.isUnityGame(item.gameId)) {
        const currentUser = this.$store.getters.user;
        await this.$store.dispatch("declineUnityChallenge", {
          platformId: item.hostId, friendId: currentUser.id, roomId: privateRoomId, gameId: item.gameId
        });
      }
      this.$store.dispatch("declineChallenge", {
        privateRoomId: privateRoomId,
      });

        await this.$store.dispatch('clearsinglealert', alertKey);

        this.$store.dispatch('clearsinglechallenge', privateRoomId);
      },
      clearSingleMessage(key) {
        this.$store.dispatch('clearsinglealert', key);
      },
      clearMessages(value) {
        this.$store.dispatch('clearAlerts', value);
      },
      acceptFriend(friendId, key) {
        this.$store.dispatch('acceptfriendrequest', friendId);
        this.$store.dispatch('clearsinglealert', key);
      },
      rejectFriend(friendId, key) {
        this.$store.dispatch('rejectfriendrequest', friendId);
        this.$store.dispatch('clearsinglealert', key);
      },
    },
  };
</script>

<template>
  <div class="white--text" style="background: #191919">
    <div class="purple-background relative pt-5 px-0">
      <div class="d-flex justify-space-between align-center w-full pr-2 pb-3 pl-5">
        <span class="white--text font-size-20 font-weight-bold">Notifications</span>
        <slot class="notificationDrawerCloseButton" name="notificationDrawerCloseButton" />
      </div>
      <v-divider color="#302d2f" />
      <v-divider color="#302d2f" />
    </div>

    <v-tabs v-model="tab" centered dark fixed-tabs text>
      <v-tabs-slider></v-tabs-slider>

      <v-tab class="px-1 px-sm-3" href="#all">
        <span class="mb-1 mr-1">All</span>
        <div>{{ alertMessages.length }}</div>
      </v-tab>
      <v-tab class="px-1 px-sm-3" href="#rewards">
        <span class="mb-1 mr-1">Rewards</span>
        <div>{{ alertRewards.length }}</div>
      </v-tab>
      <v-tab class="px-1 px-sm-3" href="#requests">
        <span class="mb-1 mr-1">Requests</span>
        <div>{{ alertRequests.length }}</div>
      </v-tab>
    </v-tabs>

    <div style="overflow: auto">
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(item, key) in tabs" :key="key" :value="item.value" dark>
          <div class="purple-background py-5 px-1">
            <v-btn class="text-none" color="white" text @click="clearMessages(item.value)">
              Mark all as read
              <v-icon class="ml-2" size="16">mdi-check-all</v-icon>
            </v-btn>
          </div>
          <ul class="pl-5 pr-3">
            <li v-for="(item, index) in item.data" :key="index">
              <notification-drawer-item
                :item="item"
                @accept="acceptChallenge"
                @acceptFriend="acceptFriend"
                @clear="clearSingleMessage"
                @deny="declineChallenge"
                @rejectFriend="rejectFriend"
              />
            </li>
          </ul>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .purple-background {
    background-color: #24073d !important;
  }

  .v-tabs::v-deep {
    .v-slide-group__prev {
      display: none !important;
    }

    .v-slide-group__content {
      position: relative;

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #302d2f;
        z-index: 1;
      }

      .v-tab {
        background: #24073d;
        font-size: 16px;
        text-transform: initial;

        div {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #383838;
          font-size: 10px;
          width: 18px;
          height: 20px;
          border-radius: 4px;
          padding-left: 2px;
        }

        &.v-tab--active {
          div {
            background: #48c965;
          }
        }
      }
    }

    .v-item-group {
      background-color: initial !important;
    }
  }

  .v-tabs-items {
    background-color: #24073d !important;
  }

  ul {
    list-style: none;

    li {
      border-bottom: 2px solid #302d2f;
    }
  }
</style>
